import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function GetRoles(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      lang: "EN",
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/security`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}


export async function GetLatestLogins(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      lang: "EN",
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/security/logins/latest`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}

export async function GetAuditLog(salesOrg: string): Promise<any> {
  const config: AxiosRequestConfig = {
    method: "GET",
    params: {
      lang: "EN",
      clientId: "100",
      salesOrg: salesOrg,
    },
    url: `${BASE_URL}/api/security/audit/log`,
  };

  return await AXIOS_INSTANCE(config)
    .then((v) => v.data)
    .catch((err) => console.error(err));
}
